import { object, string, number } from 'yup';
import { TFunction } from 'i18next';

export function makeFondFormSchema(t: TFunction) {
  return object().shape({
    code: string().required(t('form.required')),
    type: string().required(t('form.required')),
    oneTimeAmount: number().required(t('form.required')),
    regularAmount: number().required(t('form.required')),
    agio: number().required(t('form.required')),
    note: string(),
  });
}
